import { createContext } from 'react';

const gamesContext = createContext();

export default gamesContext;
